import type { PageContext } from 'vike/types';

export default function description(pageContext: PageContext) {
  const fiche = (pageContext.data as { fiche?: { code: string; label: string; description?: string | null } } | undefined)?.fiche;
  if (!fiche) return 'Fiche CEE — Solution Éco France.';
  if (fiche.description) return fiche.description.slice(0, 155) + (fiche.description.length > 155 ? '…' : '');
  return `Fiche CEE ${fiche.code} : ${fiche.label}. Primes et conditions d'éligibilité.`;
}
